// extracted by mini-css-extract-plugin
export default {"yearCircle":"home_yearCircle__rRBsq"};